import { observer } from 'mobx-react-lite';
import { Button, Container, Header, Segment, SemanticSIZES } from 'semantic-ui-react';
import { PermitFormValues } from '../../../../app/models/permit';
import { User } from '../../../../app/models/user';
import { useStore } from '../../../../app/stores/store';
import RegisterForm from '../../../user/RegisterForm';
import ShippingForm from '../../../user/ShippingForm';
import BillingForm from '../../../user/BillingForm';
import  PermitHolderContainerContent from '../../common/PermitHolderContainerContent';
import ShippingAddressContent from '../../common/ShippingAddressContent';
import BillingAddressContent from '../../common/BillingAddressContent';

interface Props {
    values: PermitFormValues,
    user: User,
    goTo: (step: number) => void,
    buttonSize: SemanticSIZES
}

export default observer(function PermitFormStep6FinalReviewLeft({ 
    values,
    user,
    goTo
 }: Props) {
    const {modalStore, userStore} = useStore();
    const {openModal} = modalStore;
    const {setShippingSameInd, setBillingSameInd} = userStore;
    
    function handlePermitHolderButton(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();

        openModal(<RegisterForm isRedirect={false} />);
    }

    function handleShippingButton(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();

        openModal(<ShippingForm isRedirect={false} />);
    }

    function handleBillingButton(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();

        openModal(<BillingForm isRedirect={false} />);
    }

    return (
       <>
            <Segment basic>
                <Segment>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Permit Holder' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={handlePermitHolderButton}
                        content='Change'
                        size='large'
                    />
                    <PermitHolderContainerContent user={user!} />
                </Segment>
                <Segment>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Shipping Address' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={handleShippingButton}
                        content='Change'
                        size='large'
                    />
                    <Container className='clear-both'>
                        {user.homeShippingSameInd === 'y' ? 
                            <>
                                <span>Using Primary Account Address!</span>
                            </>
                            : 
                            <>
                                <ShippingAddressContent user={user!}/>
                                <div>
                                    <Button
                                        fluid
                                        primary
                                        onClick={() => setShippingSameInd()}
                                    >
                                        Use Primary Address!
                                    </Button>
                                </div>
                        </>}
                    </Container>
                </Segment>
                <Segment>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Billing Address' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={handleBillingButton}
                        content='Change'
                        size='large'
                    />
                    <Container className='clear-both'>
                        {user.homeBillingSameInd === 'y' ? 
                        <>
                            <span>Using Primary Account Address!</span>
                        </>
                        : 
                        <>
                            <BillingAddressContent user={user} />
                            <div>
                                <Button
                                    fluid
                                    primary
                                    onClick={() => setBillingSameInd()}
                                >
                                    Use Primary Address!
                                </Button>
                            </div>
                        </>}
                    </Container>
                </Segment>
                <Segment>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Work Destination' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={() => goTo(3)}
                        content='Change'
                        size='large'
                    />
                    <Segment basic className='clear-both'>
                        {values.workdestCompany}<br />
                        {values.workdestAddress}<br />
                        {values.workdestAddress2}<br />
                        {`${values.workdestCity}, ${values.workdestState} ${values.workdestZipcode}`}<br />
                        {values.workdestPhone}
                    </Segment>

                </Segment>
            </Segment>
       </>
    )
})